import { render, staticRenderFns } from "./AsideImage.vue?vue&type=template&id=c67ae4a4&scoped=true&lang=pug"
import script from "./AsideImage.vue?vue&type=script&lang=js"
export * from "./AsideImage.vue?vue&type=script&lang=js"
import style0 from "./AsideImage.styl?vue&type=style&index=0&id=c67ae4a4&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67ae4a4",
  null
  
)

export default component.exports